import type { RestoreWizardConfig } from '../types'

export const WSHOOK_WIZARD_CONFIG: RestoreWizardConfig = {
  kind: 'WORKSPACE_WEBHOOK',
  kindLabel: 'Workspace Webhooks Restore',
  unitIds: { select: 'wshook-wz-1', targets: 'wshook-wz-2', plan: 'wshook-wz-3', order: 'wshook-wz-4' },
  targetScopeForm: 'WORKSPACE',
  singleRef: false,
  instances: { noun: 'workspace webhook', probeCapability: 'workspace-hook' },
}
